import React from "react";
import PT from "prop-types";

import "./styles.m.css";

export class ColombiaAds extends React.Component {
  componentDidMount() {
    // script to load the colombia ads
    let colombia;
    if (typeof colombia === "undefined") {
      colombia = colombia || {};
      colombia.fns = colombia.fns || [];
      (function() {
        var cads = document.createElement("script");
        cads.async = true;
        cads.type = "text/javascript";
        cads.src = "//static.clmbtech.com/ctn/commons/js/colombia_v2.js";
        var node = document.getElementsByTagName("script")[0];
        node.parentNode.insertBefore(cads, node);
      })();
    }
  }

  render() {
    // Pass language as props and do an equality check with pub config when returning the div from here
    // Also removing the bootstrap classes, can pass the classNames as props so that the corresponding display toggle happens
    return (
      <div
        id={this.props.data.containerId}
        data-slot={this.props.data.slot}
        data-position={this.props.data.position}
        data-section={this.props.data.section}
        data-ua={this.props.data.ua}
        style={this.props.data.inlineStyle}
        className="colombia"
        styleName="colombia-container"
      />
    );
  }
}

ColombiaAds.propTypes = {
  containerId: PT.string,
  slot: PT.string,
  position: PT.string,
  section: PT.string,
  ua: PT.string,
  inlineStyle: PT.object,
  data: PT.object
};
